export default __webpack_public_path__ + "static/media/30.351e9484.jpg";